import { AnalyticsContext } from '@carvana/eventable-clickstream';
import { useEffectOnce } from '@carvana/merch-react-hooks';
import { datadogRum } from '@datadog/browser-rum';
import { useContext } from 'react';
import type { Experiments } from '~/contracts/common';
import useExperimentsData from '../experiments/useExperimentsData';

export default function useEventExperiments(
  browserCookieIdExperiments: Partial<Experiments>,
  userIdExperiments: Partial<Experiments>
) {
  const { trackEvent } = useContext(AnalyticsContext);
  const { experimentsWithBucket, experimentsLoaded } = useExperimentsData(
    browserCookieIdExperiments,
    userIdExperiments
  );

  useEffectOnce(
    () => {
      datadogRum.setGlobalContextProperty('experiments', experimentsWithBucket);

      trackEvent('experiments', { experiments: experimentsWithBucket });
    },
    [experimentsWithBucket, trackEvent],
    experimentsLoaded
  );
}
